define('lq/dropFactory',[
    'underscore'
], function (_) {
    'use strict';

    var defaultCreationOptions = {
        dynamic: false
    };

    // todo svb - do caching properly
    var DropFactory = function (typesProvider, keepTrackOfDrops) {
        this.typesProvider = typesProvider;
        this.keepTrackOfDrops = keepTrackOfDrops;

        this.createdDropsById = {};
        this.createdDropsByName = {};
        this.createdDrops = [];
        this.createdDropsByViewModelKey = {};
    };

    DropFactory.prototype.clearCache = function () {
        this.createdDropsById = {};
        this.createdDropsByName = {};
        this.createdDrops = [];
        this.createdDropsByViewModelKey = {};
    };

    DropFactory.prototype.createDrop = function (model, creationOptions) {
        creationOptions = creationOptions || defaultCreationOptions;

        var Drop = this.typesProvider.get(model.data.type);
        var drop = new Drop(model);

        if (this.keepTrackOfDrops && !creationOptions.dynamic) { // dynamically created drops (like list items and their children) don't need to be looked up and would cause a memory leak here
            this.createdDrops.push(drop); // TODO: potential memory leak, we will need to dispose/release drops when they are no longer needed (e.g. list items)
            this.createdDropsById[model.data.id] = drop; // TODO: potential memory leak, we will need to dispose/release drops when they are no longer needed (e.g. list items)

            if (model.data.name)
                this.createdDropsByName[model.data.name] = drop; //potential memory leak, we will need to dispose/release drops when they are no longer needed (e.g. list items)

            if (model.data.viewModelKey)
                this.createdDropsByViewModelKey[model.data.viewModelKey] = drop; //potential memory leak, we will need to dispose/release drops when they are no longer needed (e.g. list items)
        }

        return drop;
    };

    DropFactory.prototype.createDrops = function (models, creationOptions) {
        var self = this;
        return _.map(models, function (model) {
            return self.createDrop(model, creationOptions);
        });
    };

    DropFactory.prototype.getAllChildMorphs = function (models, results) {
        var drops = results || [];

        var self = this;
        _.each(models, function (model) {
            drops.push(model);
            self.getAllChildMorphs(model.childDrops, drops);
        });

        return drops;
    };

    DropFactory.prototype.findDropById = function (id) {
        return this.createdDropsById[id];
    };

    DropFactory.prototype.findDropByName = function (name) {
        return this.createdDropsByName[name];
    };

    DropFactory.prototype.findDropByViewModelKey = function (viewModelKey) {
        return this.createdDropsByViewModelKey[viewModelKey];
    };

    DropFactory.prototype.getAllDrops = function () {
        return this.createdDrops;
    };

    return DropFactory;
});
